import React__default from 'react';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import createContextUtilities from '../../utils/createContextUtilities/75e5580757e6f68807f92e07850cfc0605a5ff6677179fbc573cffe4ac0a5df9.cfe-internal.js';

function createContextValue(value) {
  return {
    className: value.className,
    inputClassName: value.inputClassName,
    applySmall: function applySmall(small) {
      return value.small || small;
    },
    applyFull: function applyFull(full) {
      if (value.overrideFull) {
        return false;
      }
      return full;
    }
  };
}
var _createContextUtiliti = createContextUtilities(createContextValue({})),
  InputGroupContextProvider = _createContextUtiliti.Provider,
  useInputGroupContext = _createContextUtiliti.useContext;
var InputGroupProvider = function InputGroupProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  var context = createContextValue(value);
  return /*#__PURE__*/React__default.createElement(InputGroupContextProvider, {
    value: context
  }, children);
};

export { InputGroupProvider, useInputGroupContext };
